import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import {
  AccountVerificationInfo,
  FirstLoginScaniaService,
} from '@core/components/first-login-scania-dialog/first-login-scania.service';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from '@core/components/notifications/notifications.service';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-first-login-scania-dialog',
  templateUrl: './first-login-scania-dialog.component.html',
  styleUrls: ['./first-login-scania-dialog.component.scss'],
})
export class FirstLoginScaniaDialogComponent implements OnInit {
  form = this.fb.group({
    numberType: this.fb.control(null, [Validators.required]),
    number: this.fb.control(null, [Validators.required]),
  });

  errorMessage$ = new BehaviorSubject(null);
  loading$ = new BehaviorSubject(true);
  info: AccountVerificationInfo = null;

  constructor(
    private firstLoginScaniaService: FirstLoginScaniaService,
    private fb: UntypedFormBuilder,
    private readonly dialogRef: MatDialogRef<FirstLoginScaniaDialogComponent>,
    private readonly translateService: TranslateService,
    private notificationsService: NotificationsService,
    private keycloakService: KeycloakService
  ) {}

  ngOnInit(): void {
    this.firstLoginScaniaService.accountVerificationInfo().subscribe((info) => {
      this.loading$.next(false);
      if (info?.accountVerificationType === 'none') {
        this.dialogRef.close();
        return;
      } else {
        this.info = info;
      }
    });
  }

  onLogout(): void {
    this.keycloakService.logout();
  }

  onSubmit(): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    this.loading$.next(true);
    this.errorMessage$.next(null);
    this.firstLoginScaniaService
      .validateCustomer({
        accountVerificationType: this.info.accountVerificationType,
        verificationKey: this.info.verificationKey,
        verificationData: {
          [this.form.value.numberType]: this.form.value.number,
        },
      })
      .pipe(
        catchError(() => {
          this.handleVerificationResponse(status);
          return of(null);
        }),
        finalize(() => {
          this.loading$.next(false);
        })
      )
      .subscribe((status) => {
        this.handleVerificationResponse(status);
      });
  }

  private handleVerificationResponse(status: string): void {
    if (status === 'VALID') {
      this.dialogRef.close();
    } else {
      this.errorMessage$.next(
        this.translateService.instant(`SCANIA_ID_VERIFICATION.STATUS.${status ?? 'INTERNAL_ERROR'}`)
      );
    }
  }
}
